import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, catchError, from, of, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IsAuthenticatedGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return from(this.authService.initialize()).pipe(
      switchMap((res) => {
        if (!this.authService.isLoggedIn()) {
          return throwError(() => new Error('Not authenticated'));
        }

        return of(true);
      }),
      catchError((error) => {
        this.router.navigate(['sign-in'], { queryParams: route.queryParams });
        return of(false);
      })
    );
  }
}
